import React from 'react';

const SessionProvider = ({ children }) => {
    return children
};

export default React.memo(SessionProvider);
